import React, { useContext } from 'react';
import { StyleSheet } from 'react-native';
import { Text, ThemeContext, TranslationsContext } from '..';

/*eslint-disable react-native/no-unused-styles*/
function getStyles(theme: Theme) {
  return StyleSheet.create({
    tax: {
      fontSize: theme.font.size.small,
      fontStyle: 'italic',
      color: theme.buttons.DEFAULT.textColor,
      marginBottom: 8,
    },
  });
}

export const TaxFootnote = (props: Props) => {
  const theme = useContext(ThemeContext);
  const styles = getStyles(theme);
  const translations = useContext(TranslationsContext);
  const { isExemptedFromTax } = props;

  const taxLabelKey = isExemptedFromTax ? 'exclusiveDescription' : 'inclusiveDescription';

  return (
    <Text style={styles.tax} {...props}>
      {translations.components.taxFootnote[taxLabelKey]}
    </Text>
  );
};

export type Props = {
  isExemptedFromTax?: boolean;
};
